import { CarePlan, PatientCarePlanControllerApi } from "../../services";
import { getConfigObject, useMutationWithLoading } from "../../utils/utils";

/**
 * @author Rajkumar Rathod
 */
export const usePatientCareplanUpdate = () =>
  useMutationWithLoading(
    async (params: { carePlan: CarePlan; xTENANTID?: string }) =>
      new PatientCarePlanControllerApi(getConfigObject()).updateCarePlan(
        params.carePlan,
        params.xTENANTID
      )
  );
